export const SET_PAYMENTS_TABLE = "SET_PAYMENTS_TABLE"
